module.exports = __webpack_public_path__ + "img/img002.7777cbdd.png";